export const MAX_PLAYERS = 7;
export const MIN_PLAYERS = 3;
export const ROOM_CODE_LENGTH = 4;
/** Crew portraits. Ids are stable; the artwork lives in the client. */
export const AVATARS = [
    'pilot',
    'navigator',
    'engineer',
    'medic',
    'scanner',
    'gunner',
    'droid',
    'alien',
    'captain',
    'rookie',
    'mechanic',
    'astro'
];
/** Faces and colours are chosen independently, so 12 x 12 combinations. */
export const AVATAR_COLORS = [
    'pink',
    'coral',
    'amber',
    'yellow',
    'lime',
    'green',
    'teal',
    'cyan',
    'blue',
    'indigo',
    'violet',
    'magenta'
];
/** The expression drawn inside the visor. */
export const MOODS = ['happy', 'grin', 'cool', 'wink', 'shock', 'grumpy'];
export function isMood(value) {
    return typeof value === 'string' && MOODS.includes(value);
}
export function moodOrDefault(value) {
    return isMood(value) ? value : 'happy';
}
export function isAvatarId(value) {
    return typeof value === 'string' && AVATARS.includes(value);
}
export function isAvatarColor(value) {
    return typeof value === 'string' && AVATAR_COLORS.includes(value);
}
export function avatarOrDefault(value, seed = 0) {
    if (isAvatarId(value))
        return value;
    return AVATARS[seed % AVATARS.length];
}
export function avatarColorOrDefault(value, seed = 0) {
    if (isAvatarColor(value))
        return value;
    return AVATAR_COLORS[seed % AVATAR_COLORS.length];
}
export function normaliseRoomCode(code) {
    return code.trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, ROOM_CODE_LENGTH);
}
export function sanitiseName(name) {
    const clean = name.replace(/\s+/g, ' ').trim().slice(0, 16);
    return clean.length > 0 ? clean : 'Rookie';
}
//# sourceMappingURL=protocol.js.map